// Mixpanel's reserved prefix for a native anonymous device id (the SDK's
// internal `DEVICE_ID_PREFIX`). `identify()` rejects any value carrying it, so a
// "$device:"-prefixed id is a device id, not a user id.
const MIXPANEL_DEVICE_ID_PREFIX = '$device:';

/** Whether a distinct id is one of Mixpanel's native anonymous device ids. */
export const hasMixpanelDeviceIdPrefix = (distinctId: string): boolean =>
  distinctId.startsWith(MIXPANEL_DEVICE_ID_PREFIX);

/** The bare device id with Mixpanel's `$device:` prefix removed (no-op when absent). */
export const stripMixpanelDeviceIdPrefix = (distinctId: string): string =>
  hasMixpanelDeviceIdPrefix(distinctId)
    ? distinctId.slice(MIXPANEL_DEVICE_ID_PREFIX.length)
    : distinctId;
